/**
 * Наименования панелей
 */
export default {
  INDEX: "INDEX",
  CREATE_TRIP: "CREATE_TRIP",
  DETAIL_INFO_TRIP: "DETAIL_INFO_TRIP",
};
